import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import TiersBox from './TiersBox';
import initActionsCreator from './redux/tiersInit';

export const getTiersWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: TiersBox,
  initActionsCreator,
});
